<template>
  <div class="container" ref="container" v-if="item">
    <Head v-if="meta.title" v-bind:meta="meta" :key="rkey + item.id"></Head>
    <Header />
    <Navigation />
    <Breadcrumbs
      v-if="breadcrumbs"
      v-bind:breadcrumbs="breadcrumbs"
      :key="rkey - item.id"
    ></Breadcrumbs>
    <ItemPlayerContent
      :item="item"
      :slides="slides"
      :collection="collection"
      :tags="tags"
      :meta="meta"
      v-show="!full_size"
      :key="rkey"
      :fs="from_search"
    ></ItemPlayerContent>
    <ItemPlayerFullsize
      :slides="slides"
      :collection="collection"
      v-if="full_size"
    ></ItemPlayerFullsize>
    <ItemPlayerRelated
      :item="item"
      :slides="slides"
      :collection="collection"
      v-show="!full_size"
      v-if="collection"
    ></ItemPlayerRelated>
    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import NProgress from "nprogress";

//import VuePlyr from 'vue-plyr';
import "vue-plyr/dist/vue-plyr.css";

import { eventBus } from "@/main.js";

// components

import Head from "@/components/Common/Head.vue";
import Header from "@/components/Header/Header.vue";
import ItemPlayerContent from "@/components/ItemPlayer/ItemPlayerContent.vue";
import ItemPlayerFullsize from "@/components/ItemPlayer/ItemPlayerFullsize.vue";
import ItemPlayerRelated from "@/components/ItemPlayer/ItemPlayerRelated.vue";
import Navigation from "@/components/Common/Navigation.vue";
import Footer from "@/components/Footer/Footer.vue";
import Breadcrumbs from "@/components/Common/Breadcrumbs.vue";

export default {
  name: "ItemPlayer",
  props: ["apiCall", "breadcrumbsTitle"],
  components: {
    Head,
    Header,
    Navigation,
    ItemPlayerContent,
    ItemPlayerRelated,
    ItemPlayerFullsize,
    Breadcrumbs,
    Footer,
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      item: null,
      item_type: null,
      title: null,
      description: null,
      tags: null,
      meta: null,
      breadcrumbs: null,
      slides: null,
      rkey: Math.random(),
      collection: null,
      page: 1,
      full_size: false,
      from_search: null,
      prevRoute: null
    };
  },
  methods: {
    fetchData() {
      NProgress.start();
      // fetching basic item data
      axios
        .get(this.$config.API_PATH + this.apiCall)
        .then((_resp) => {
          this.parseData(_resp);
        })
        .catch((error) => {
          console.log(error);
          this.$router.push({
            name: "NotFound",
          });
        });
    },
    generatePaths(id) {
      // id = item.item_type.id
      if (id == 20) return "/fotografia";
      if (id == 19) return "/dokument";
      if (id == 24) return "/eksponat";
      if (id == 28) return "/nagranie";
    },
    parseData(_d) {
      // fetching item information and building meta
      this.item_type = _d.data.item_type.id;

      let _metadata = _d.data.element_texts;

      if (_metadata.find((x) => x.element.id == "50"))
        this.title = _metadata.find((x) => x.element.id == "50").text;

      if (_metadata.find((x) => x.element.id == "41"))
        this.description = _metadata.find((x) => x.element.id == "41").text;

      this.tags = _d.data.tags;

      

      // getting item img for meta and build that objects

      
      axios
        .get(this.$config.API_PATH + "files?item=" + this.$route.params.id)
        .then((_img) => {
          this.meta = {
            url:
              window.location.origin +
              this.generatePaths(this.item_type) +
              "/" +
              this.$route.params.id,
            description: this.description,
            title: this.title.replace(/(<([^>]+)>)/gi, ""),
            og_type: "website",
            og_image: _img.data[0].file_urls.thumbnail,
          };

          // building item object for props

          //console.log(_d);

          // if not collection

          let _collection = null;
          if (_d.data.collection) _collection = _d.data.collection.id;

          //console.log(_d.data.collection)

          this.item = {
            id: _d.data.id,
            title: this.title,
            type: _d.data.item_type.id,
            collection: _collection,
            nextprev: {
              next: null,
              prev: null,
            },
          };

          // next - prev

          if (_d.data.next_item) {
            this.item.nextprev.next = {
              id: _d.data.next_item.id,
              path: this.generatePaths(_d.data.next_item.item_type_id),
            };
          }

          if (_d.data.prev_item) {
            this.item.nextprev.prev = {
              id: _d.data.prev_item.id,
              path: this.generatePaths(_d.data.prev_item.item_type_id),
            };
          }

          //console.log([this.collection, _d.data.collection]);

          // check if second load (with collection available already)
          if (this.collection) {
            // if second load, check if collection is the same, if not = build new collection
            if (this.collection.id != _d.data.collection.id) {
              this.collection = _d.data.collection;
            }
            if (this.collection.id == _d.data.collection.id) {
              // set slides
              // reload ItemPlayerContent
              this.rkey = Math.random();
              NProgress.done();
              return;
            }
          } else {
            // if collection is null
            // first load
            this.collection = _d.data.collection;
          }

          if (this.collection) {
            // building slides

            this.slides = [];

            let _path = this.generatePaths(_d.data.item_type.id);

            this.slides.push({
              id: _d.data.id,
              title: this.title,
              file_urls: _img.data[0].file_urls,
              type: _d.data.item_type.id,
              path: _path,
            });
          }

          this.rebuildBreadcrumbs();

          let _this = this;

          setTimeout(function () {
            NProgress.done();
            // let's build collection items and metadata
            if (_this.collection) _this.buildCollection();
          }, 500);
        });

      // end loading
    },
    buildCollection() {
      NProgress.start();
      axios
        .all([
          axios.get(
            this.$config.API_PATH +
              "items?collection=" +
              this.item.collection +
              "&page=" +
              this.page
          ),
          axios.get(
            this.$config.API_PATH + "collections/" + this.item.collection
          ),
        ])
        .then(
          axios.spread((..._resp) => {
            // obtain collection metadata and first load of items

            // get collection title

            let _cmetadata = _resp[1].data.element_texts;
            let _ctitle = "";

            if (_cmetadata.find((x) => x.element.id == "50"))
              _ctitle = _cmetadata.find((x) => x.element.id == "50").text;

            this.collection = {
              id: _resp[1].data.id,
              title: _ctitle,
              all_items_count: _resp[1].data.items.count,
              items_count:
                _resp[1].data.items.count - _resp[1].data.items.biograms_count,
            };

            _resp[0].data.forEach((_item) => {
              // don't need biograms and current Item
              if (_item.item_type.id != "18" && _item.id != this.item.id) {
                // get titles

                let _title = "Brak tytułu";

                if (_item.element_texts.find((x) => x.element.id == "50"))
                  _title = _item.element_texts.find(
                    (x) => x.element.id == "50"
                  ).text;

                axios
                  .get(this.$config.API_PATH + "files?item=" + _item.id)
                  .then((_img) => {
                    this.slides.push({
                      id: _item.id,
                      title: _title,
                      file_urls: _img.data[0].file_urls,
                      type: _item.item_type.id,
                      path: this.generatePaths(_item.item_type.id),
                    });
                  });
              }
            });

            NProgress.done();

            if (this.collection.items_count > this.slides.length) {
              this.page++;
              this.buildCollection();
            }
          })
        );
    },
    rebuildBreadcrumbs() {
      

      this.breadcrumbs = {
        parent_title: "",
        parent_uri: "",
        self_title: "",
        self_uri: window.location.href,
      };


      if (this.item_type == 20) {
        this.breadcrumbs.parent_title = "Fotografie";
        this.breadcrumbs.parent_uri = "/fotografie";
      }

      if (this.item_type == 19) {
        this.breadcrumbs.parent_title = "Dokumenty";
        this.breadcrumbs.parent_uri = "/dokumenty";
      }

      if (this.item_type == 24) {
        this.breadcrumbs.parent_title = "Eksponaty";
        this.breadcrumbs.parent_uri = "/eksponaty";
      }

      if (this.item_type == 28) {
        this.breadcrumbs.parent_title = "Nagrania";
        this.breadcrumbs.parent_uri = "/nagrania";
      }

      if (this.from_search) {
        this.breadcrumbs = {
          parent_title: "Wyniki wyszukiwania",
          parent_uri: this.from_search.path,
          self_uri: window.location.href,
        };
      }

      if(this.prevRoute.name !== null && this.prevRoute.name !== undefined) {

        // only if prevRoute !null

        if(this.prevRoute.name == "Tags") {
          this.breadcrumbs.parent_title = "Etykieta: " + this.prevRoute.params.tag; 
          this.breadcrumbs.parent_uri = this.prevRoute.path;
        }

        if(this.prevRoute.name == "Collection") {
          this.breadcrumbs.parent_title = "Kolekcja: " + this.collection.collection_title;
          this.breadcrumbs.parent_uri = this.prevRoute.path;
        }

        if(this.prevRoute.name == "BiogramRelated" || this.prevRoute.name == "Biogram") {
          this.breadcrumbs.parent_title = "Powiązane: " + this.prevRoute.params.biogram_title;
          this.breadcrumbs.parent_uri = this.prevRoute.path;
        }

      } 

    }
  },
  mounted() {
    this.fetchData();
    let _this = this;
    eventBus.$on("fullSize", () => {
      _this.full_size = true;
    });
    eventBus.$on("closeFullSize", () => {
      _this.full_size = false;
    });
    eventBus.$on("getAnotherItem", () => {
      _this.full_size = false;
      _this.fetchData();
    });
  },
  beforeRouteEnter(to, from, next) {
    // check previous route
    //let _this = this;
    next((vm) => {
      vm.prevRoute = from;
      //this.rebuildBreadcrumbs();
      if (from.name == "Search") {
        vm.from_search = {
          path: from.path,
        };
      }
      if(from.name == "Collection") {
      }
      if(from.name == "Tags") {
      }
    });
  },
  watch: {
    $route() {
      //this.fetchData()
      //this.rebuildBreadcrumbs()
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ItemPlayer/ItemPlayer.vue